import { updateUserCart } from "Root/checkout/redux/slices/checkoutUserCartSlice";
import { useDispatch } from "react-redux";
const useCartHandlers = ({ cart, setCart, updatingUserCart, addItemToCart, removeItemFromCart }) => {
    const dispatch = useDispatch();
    function removeFromCart(item) {
        if (updatingUserCart)
            return;
        const cart_copy = { ...cart };
        cart_copy[item] = 0;
        setCart(cart_copy);
        dispatch(updateUserCart(cart_copy));
        removeItemFromCart && removeItemFromCart(item);
    }
    function addToCart(item) {
        if (updatingUserCart)
            return;
        const cart_copy = { ...cart };
        cart_copy[item] = 1;
        setCart(cart_copy);
        dispatch(updateUserCart(cart_copy));
        addItemToCart(item);
    }
    return {
        addToCart,
        removeFromCart,
    };
};
export default useCartHandlers;
